export const SHOW_BILLING_ALERT_ON_PAGES = [
  "dashboard",
  "events",
  "customers",
  "products",
  "reports",
];
